import FormInputIdentifier from "@repo/components/src/forms/identifier";
import { VStack } from "@repo/components/src/ui/vstack";
import { ComponentProps } from "react";

import RegistryMatchCard from "./RegistryMatchCard";
import type { TaxProfileFormState } from "./useTaxProfileForm";
import type { TaxProfileFieldData } from "./types";

type Props = {
  field: TaxProfileFieldData;
  form: TaxProfileFormState;
  countryCode: string;
  size: ComponentProps<typeof FormInputIdentifier>["size"];
};

export default function IdentifierField({
  field,
  form,
  countryCode,
  size,
}: Props) {
  return (
    <VStack space="lg">
      <FormInputIdentifier
        control={form.formProps.control}
        name="taxId"
        countryCode={countryCode}
        allowedTypes={field.identifierTypes}
        required={field.required}
        disabled={false}
        className=""
        size={size}
        labelSize={size}
      />
      {field.registryLookup ? (
        <RegistryMatchCard
          formProps={form.formProps}
          registryMatch={form.registryMatch}
          identifierTypes={field.identifierTypes}
          hasBusinessActivityField={form.hasBusinessActivityField}
        />
      ) : null}
    </VStack>
  );
}
